import styled from "styled-components"
import { colors } from "../top-bar/core/colors"
import {
  SliderWrapperStyles,
  SlideStyles,
  SlideContentStyles,
  SlideDescriptionStyles,
  RowStyles,
  PageNumberStyles,
} from "./slider-styles"

interface ISlide {
  bgImg: string
}

export const SliderWrapper = styled.div`
  margin-bottom: 60px;
  .slick-prev {
    left: 25px;
    z-index: 10;
  }
  .slick-next {
    right: 25px;
    z-index: 10;
  }
  ${SliderWrapperStyles}
`

export const Slide = styled.div<ISlide>`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 400px;
  height: 506px;
  background-image: url(${props => props.bgImg});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  ${SlideStyles}
`

export const SlideContent = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 26px 40px;
  align-items: center;
  min-height: 98px;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  ${SlideContentStyles}
`

export const SlideDescription = styled.p`
  ${SlideDescriptionStyles}
`

export const PageNumber = styled.span`
  color: ${colors.gray};
  ${PageNumberStyles}
`

export const Row = styled.div`
  display: flex;
  ${RowStyles}
`
